import { createStyles } from "@mantine/core";
import { breakpoints } from "theme";

import { Image } from "components/Image";

interface Params {
  image: Image;
}

export const useStyles = createStyles((_, { image: { src } }: Params) => ({
  illustration: {
    backgroundImage: `url("${src}")`,
    backgroundSize: "cover",
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    height: 250,

    [`${breakpoints.mobileSm}`]: {
      height: 400,
    },
  },
}));
